<template>
<div>

<div class="grouptwo ">
<div >

                                                      

     <div class="fileUpload btn btn-primary">
       <img :src="profileobject.imagefile" alt="img" id="output"  width="50" height="50" top="0" right="0" radius="10"  class="profileimage"/>
 <input type="file" class="upload"   accept="image/*" name="image"  id="file" @change="loadFile()">           

</div></div>

<p>Welcome to<b> Work Notion</b>
<br>please provide basic information</p>
<button class="button buttonleft "  @click="createprofile" >+Create Profile</button>
</div>
<div class="groupone">

</div>
<div class="columnbackground">
<p>VIDEO PROFILE</p>
<div class="groupbutton">
<button class="button ">Upload</button>&nbsp;&nbsp;&nbsp;
<button class="button">Create</button>
</div>
</div>
<div class="columnbackground">
<p>VIDEO RESUME</p>
<div class="groupbutton">
<button class="button">Upload</button>&nbsp;&nbsp;&nbsp;
<button class="button">Create</button>
</div>
</div>
</div>  
</template>
<script>
 export default{
      props:['profileobject'],
   components: {
              
           },
   
   
       data(){
           return{
              
             }  },
           methods:{
               
               createprofile(){
   this.$emit('profileChanged',this.profileobject);
             this.profileobject.profilehome = false
             this.profileobject.profile = true
             this.profileobject.editprofile=false
             this.profileobject.profilecreation='profile'
               },
               
                         loadFile:function() {                          
                             
      	var image = document.getElementById('file').value;
      
  this.profileobject.imagefile = URL.createObjectURL(event.target.files[0]);
 
   }, 
           }
                                
           
           
           }
</script>